import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";
import { useNavigate } from "react-router-dom";

/**
 * Página de mantenimiento para /clinical-info/high-cost.
 * Reemplaza temporalmente a HighCostPage mientras dura el proceso de
 * optimización del módulo. Al volver online, restaurar la ruta original
 * en clinical-info.routes.js.
 */
const HighCostMaintenancePage = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8, px: 2 }}>
      <Paper
        sx={{
          maxWidth: 560,
          width: "100%",
          p: 4,
          textAlign: "center",
          borderTop: "4px solid",
          borderColor: "warning.main",
        }}
      >
        <BuildCircleOutlinedIcon
          sx={{ fontSize: 56, color: "warning.main", mb: 1 }}
        />
        <Typography variant="h5" fontWeight={700} gutterBottom>
          High Cost — under maintenance
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          The High Cost module is temporarily offline today and tomorrow
          while we run an optimization process.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Service will resume automatically once the work is complete.
          Other clinical-info tabs (Discharged, Admitted, Emergency,
          High Risk) keep working as usual.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate("/Main")}
          sx={{ textTransform: "none" }}
        >
          Back to dashboard
        </Button>
      </Paper>
    </Box>
  );
};

export default HighCostMaintenancePage;
